export default __webpack_public_path__ + "static/media/UAE.7696e277.svg";